import React from 'react'
import PropTypes from 'prop-types'
import { PencilSimpleLine } from '@phosphor-icons/react'
import { routes } from '../../router/routes'
import { useChipStyles } from './styles'
import useBadgeTranslation from './translation'

/* ---- minimalist inline chip: tint pill + pencil disc, for headers/bylines ----
 * Renders as a link to the "About our content" page. */
const HumanMadeChip = ({ dataTest = 'human-made-chip', style }) => {
  const classes = useChipStyles()
  const { t, ready } = useBadgeTranslation()

  // The chip is copy-only, so there is nothing worth showing until its bundle has landed.
  if (!ready) return null

  const text = t('human_made_chip_label')

  return (
    <a
      href={routes['about-our-content'].path}
      target='_blank'
      rel='noopener noreferrer'
      data-test={dataTest}
      aria-label={t('human_made_chip_aria', { label: text })}
      className={classes.chip}
      style={style}
    >
      <span className={classes.chipDisc}>
        <PencilSimpleLine size={14} weight='bold' />
      </span>
      {text}
    </a>
  )
}

HumanMadeChip.propTypes = {
  dataTest: PropTypes.string,
  style: PropTypes.object
}

export default HumanMadeChip
